<template>
  <div id="grid-evaluacion">
    <v-container grid-list-xl fluid>
      <v-layout>
        <carga-masiva
          :apiValidateDocument="apiValidateDocument"
          :apiSaveDocument="apiSaveDocument"
          :apiDownloadDocument="apiDownloadDocument"
          :templateTitle="templateTitle"
        ></carga-masiva>
      </v-layout>
      <v-layout class="d-flex pa-2">
        <div class="d-flex pa-2" xs12 sm6>
          <v-text-field
            width="300px"
            v-model="txtBusqueda"
            placeholder="Ingresa el nombre o código para la busqueda por palabra clave"
            single-line
          ></v-text-field>
          <v-btn
            color="primary"
            @click="loadData()"
            :disabled="txtBusqueda.length < 3"
            class="shrink"
            ><v-icon dark left>search</v-icon>Buscar</v-btn
          >
          <v-btn
            color="secondary"
            @click="limpiaBuscador()"
            :disabled="txtBusqueda.length < 3"
            class="shrink"
            ><v-icon dark left>backspace</v-icon>Limpiar</v-btn
          >
        </div>
      </v-layout>

      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :headers="headers"
              :items="itemsEvaluacion"
              :pagination.sync="miPaginacion"
              hide-actions
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left" nowrap>
                  {{ props.item.candidato.rut + "-" + props.item.candidato.dv }}
                </td>
                <td class="text-xs-left">{{ props.item.candidato.nombre }}</td>
                <td class="text-xs-left">
                  {{ props.item.resultadoEval.descripcion }}
                </td>
                <td class="text-xs-left">{{ props.item.fechaEvaluacion }}</td>
                <td>
                  <v-btn
                    v-if="
                      usuarioLoggedTipe == 'PROVEEDOR' ||
                      usuarioLoggedTipe == 'ADMINISTRADOR'
                    "
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    small
                    title="Editar evaluacion"
                    @click="
                      editEvaluacion(
                        props.item.id,
                        props.item.candidato.rut,
                        props.item.candidato.dv,
                        props.item.candidato.nombre,
                        props.item.candidato.apellido,
                        props.item.candidato.apellido1
                      )
                    "
                  >
                    <v-icon>open_in_new</v-icon>
                  </v-btn>
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Ver evaluacion"
                    @click="
                      viewEvaluacion(
                        props.item.id,
                        props.item.candidato.rut,
                        props.item.candidato.dv,
                        props.item.candidato.nombre,
                        props.item.candidato.apellido,
                        props.item.candidato.apellido1
                      )
                    "
                  >
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </template>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <template
              v-if="
                usuarioLoggedTipe == 'PROVEEDOR' ||
                usuarioLoggedTipe == 'ADMINISTRADOR'
              "
            >
              <v-btn
                class="btn-sigas"
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
              >
                <v-icon>open_in_new</v-icon> </v-btn
              >&nbsp;Editar evaluacion
            </template>
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>remove_red_eye</v-icon> </v-btn
            >&nbsp;Consultar evaluacion
          </v-card-actions>
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="itemsEvaluacion.length"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          v-if="botonDescarga == true"
          color="primary"
          @click="descargaMasiva()"
          >Descarga</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import DataAdjunto from "@/components/AdjuntoData.vue";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import CargaMasiva from "@/components/CargaMasiva.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "grid-evaluacion",

  components: {
    AlertEmpty,
    Loading,
    DataAdjunto,
    CargaMasiva,
    LoadingDescarga,
  },
  props: {
    rowsTable: "",
    tipeView: "",
  },

  data() {
    return {
      txtBusqueda: "",
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      botonDescarga: false,
      dialogLoading: false,
      selected: [],
      loading: false,
      loading1: false,
      tipeArchive: "",
      alerta: false,
      dialog: false,
      id: "",
      idContrato: "",
      headers: [
        {
          text: "Rut Reclutados",
          align: "left",
          sortable: false,
          value: "rut",
        },
        { text: "Reclutado/a", sortable: false, value: "candidato" },
        { text: "Evaluacion", sortable: false, value: "evaluacion" },
        { text: "Fecha de la Evaluación", sortable: false, value: "fecha" },
        { text: "Accion", sortable: false, value: "" },
      ],
      usuarioLoggedTipe: "",
      itemsEvaluacion: [],
      idUserLogged: "",
      proceso: "",
      //----CARGA MASIVA---
      apiValidateDocument: "",
      apiSaveDocument: "",
      apiDownloadDocument: "",
      templateTitle: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 5000);
    },
  },

  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;

    //se indican las apis a utilizar
    this.apiValidateDocument = "/candidatos/evaluacion/processFile";
    this.apiSaveDocument = "/candidatos/evaluacion/carga";
    this.apiDownloadDocument = "/candidatos/evaluacion/downloadPlantilla/";
    this.templateTitle = "Planilla_Evaluacion";

    this.loadData();
  },
  mounted() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    async loadContratacionFilter() {
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        txtBusqueda: this.txtBusqueda,
      };
      return await axios
        .post("/candidatos/evaluacion/filters", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;

      this.itemsEvaluacion = await this.loadContratacionFilter();
      this.miPaginacion.totalItems = this.itemsEvaluacion.length;

      if (this.itemsEvaluacion.length > 0) {
        this.alerta = false;
        this.botonDescarga = true;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    limpiaBuscador() {
      this.fechaValue = "";
      this.rutCandidatoValue = "";
      this.loadData();
    },
    editEvaluacion(id, rut, dv, nombre, apellido, apellido1) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "EvaluacionRegistra",
          params: {
            id: id,
            rut: rut,
            dv: dv,
            nombre: nombre,
            apellido: apellido,
            apellido1: apellido1,
            tipeView: "modifica",
          },
        });
      }, 1000);
    },
    viewEvaluacion(id, rut, dv, nombre, apellido, apellido1) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "EvaluacionRegistra",
          params: {
            id: id,
            rut: rut,
            dv: dv,
            nombre: nombre,
            apellido: apellido,
            apellido1: apellido1,
            tipeView: "consulta",
          },
        });
      }, 1000);
    },
    reload() {
      setTimeout(() => {
        this.$parent.$parent.reloadDocumento();
        // this.$router.go(-1)
      }, 1000);
    },
    descargaMasiva() {
      this.dialogLoading = true;
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        txtBusqueda: this.txtBusqueda,
      };
      axios
        .post("/candidatos/evaluacion/download", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "DESCARGA_EVALUACION.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
